<template>
    <stepper></stepper>
</template>

<script>
import Stepper from "../../../components/partials/Stepper";

export default {
    name      : "ReservationAdvance",
    components: {Stepper},
    mounted() {
    }
}
</script>
